import { Button } from "@progress/kendo-react-buttons";
import { DatePicker, DatePickerChangeEvent } from "@progress/kendo-react-dateinputs";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { MaskedTextBox, MaskedTextBoxProps, TextBox } from "@progress/kendo-react-inputs";
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { protectedResources } from "../../authConfig";
import { useNotificationAPI } from '../../components/NotificationProvider';
import { kitSizes } from "../../models/kit";
import { loginPrompt } from "../../utils/loginPrompt";
import { AppUserContext } from '../../components/PvsContextProvider';

const pageTitle = 'Barcode Import';

const KitImport = () => {
    const { addNotification, addNotifications } = useNotificationAPI();
    const appUserContext = useContext(AppUserContext);
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [lotNumber, setLotNumber] = useState("0000");
    const [kitSize, setKitSize] = useState(kitSizes[1]);
    const [lotSize, setLotSize] = useState(0);
    const [expirationDate, setExpirationDate] = useState(new Date() as Date | null);

    const kitSizeChange = (e: DropDownListChangeEvent) => {
        setKitSize(e.value);
    }

    const lotSizeChange = (e: any) => {
        const parsed = Number.parseInt(e.value);
        if (parsed) {
            setLotSize(parsed);
        }
    }

    const expirationDateChange = (e: DatePickerChangeEvent) => {
        setExpirationDate(e.value);
    }

    const importKits = () => {
        if (lotNumber === "0000" || Number.isNaN(Number.parseInt(lotNumber))) {
            addNotification('Lot Number must be greater than 0', pageTitle, 'info');
            return;
        }
        if (lotSize <= 0) {
            addNotification('Lot Size must be greater than 0', pageTitle, 'info');
            return;
        }
        const importKitsRequest = {
            LotNumber: lotNumber,
            KitSize: kitSize.id,
            LotSize: lotSize,
            ExpirationDate: expirationDate
        };
        setIsLoading(true);
        loginPrompt('POST', protectedResources.apiKit.endpoint + "ImportKits", importKitsRequest, addNotifications,
            (data: any) => {
                if (data?.item) {
                    addNotification('Import Successful: ' + lotNumber + '-' + kitSize.shortText, pageTitle, 'success');
                    navigate("/barcode-list");
                }
                setIsLoading(false);
            });
    }

    return (
        <>
            <div style={{ width: "100%", maxWidth: "300px" }}>
                <div>
                    Lot Number:<br></br>
                    <MaskedTextBox mask="0000" defaultValue="0000" value={lotNumber} onChange={(e: MaskedTextBoxProps) => { setLotNumber(e.value as string) }}></MaskedTextBox>
                </div>
                <div>
                    Kit Size:<br></br>
                    <DropDownList dataItemKey={"id"} value={kitSize} textField={"text"} data={[kitSizes[1], kitSizes[2]]} onChange={kitSizeChange} title={'Kit Size'}></DropDownList>
                </div>
                <div>
                    Lot Size:<br></br>
                    <TextBox value={lotSize} onChange={lotSizeChange} title={'Lot Size'}></TextBox>
                </div>
                <div>
                    Expiration Date:<br></br>
                    <DatePicker value={expirationDate} onChange={expirationDateChange} title={'Expiration Date'}></DatePicker>
                </div>
            </div>
            <br></br>
            <Button disabled={isLoading || appUserContext.isReadOnly} onClick={importKits}>Import</Button>
        </>
    );
}

export default KitImport;